import { Params } from '@angular/router';

/**
 * Combines unique numeric IDs from URL parameters and additional parameters into an array.
 *
 * @param {Params} queryParams - An object representing URL query parameters, which may contain a 'transports' property.
 * @param {Params} params - An object containing additional parameters, which may include an 'id' property.
 * @returns {number[]} An array of unique numeric IDs extracted from the input parameters.
 *
 * @example
 * const queryParams = { transports: '1,2,3' };
 * const params = { id: '4' };
 * const result = combineIdsFromUrlParams(queryParams, params);
 * // result will be [1, 2, 3, 4]
 */
export const combineIdsFromUrlParams = (queryParams: Params, params: Params): number[] => {
	const combinedIds = new Set<number>();

	const addIdIfValid = (id: string | undefined) => {
		const numId = +id;
		if (id && !isNaN(numId) && id.trim() !== '') {
			combinedIds.add(numId);
		}
	};

	addIdIfValid(params['id']);

	if (queryParams['transports']) {
		queryParams['transports'].split(',').forEach((id: string) => addIdIfValid(id));
	}

	return Array.from(combinedIds);
};
